import React from 'react'
import { Container, Button, Alert } from '@sainsburys-tech/fable'
import api from '../../utils/api'
import LoadingOverlay from '../LoadingOverlay'

class TaskSelection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      options: Array.isArray(props.task?.taskSelectedItems) ? props.task.taskSelectedItems : [],
      error: false,
    }
  }

  componentDidMount() {
    this.getTaskList()
  }

  getActiveOptions = () => {
    const { task } = this.props
    if (Array.isArray(task?.taskSelectedItems) && task.taskSelectedItems.length > 0) {
      return task.taskSelectedItems
    }
    return this.state.options
  }

  setOptionChecked = (value, checked) => {
    this.setState((prevState) => {
      const updated = prevState.options.map(opt => (
        String(opt.value) === String(value)
          ? { ...opt, defaultChecked: checked }
          : opt
      ))
      return { ...prevState, options: updated, error: false }
    })
  }

  isValidCheckboxItems = () => {
    const options = this.getActiveOptions()
    const isChecked = Array.isArray(options) && options.some(o => o && o.defaultChecked)
    this.setState({ error: !isChecked })
    return isChecked
  }

  handleSubmit = () => {
    debugger
    const { history, setSiteTask, getTask } = this.props
    if (this.isValidCheckboxItems()) {
      const options = this.getActiveOptions()
      setSiteTask(options)
      history.push('/task/time')
    } else {
      this.setState({ error: true })
    }
  };

  getTaskList = () => {
    const { task } = this.props
    const loadOptions = api
      .getAllTasks()
      .then((data) => {
        const hasSelected = Array.isArray(task?.taskSelectedItems) && task.taskSelectedItems.length > 0
        if (hasSelected) return

        this.setState({
          options: data.map(item => ({
            value: item.id,
            label: item.taskName,
            defaultChecked: false,
          }))
        })
      })
      .catch(e => console.log(e))
    return loadOptions
  };

  render() {
    const options = this.getActiveOptions()
    const hasOptions = Array.isArray(options) && options.length > 0 && options.some(o => o && o.label)

    if (!hasOptions) {
      return <LoadingOverlay hasBackground text="Loading..." />
    }
    return (
      <div className="dsib-taskSelection">
        <Container size="xl">
          <div className="dsib-taskSelection__inner">
            <h2 className="dsib-taskSelection__title">What tasks are you in store to do?</h2>

            <div className="dsib-taskSelection__list" role="group" aria-label="Task selection">
              {options.map(opt => (
                <label key={opt.value} className="dsib-taskSelection__option">
                  <input
                    type="checkbox"
                    className="dsib-taskSelection__checkbox"
                    checked={!!opt.defaultChecked}
                    onChange={e => this.setOptionChecked(opt.value, e.target.checked)}
                  />
                  <span className="dsib-taskSelection__label">{opt.label}</span>
                </label>
              ))}
            </div>

            {this.state.error && (
            <div className="dsib-taskSelection__error">
              <Alert status="error" isOpen message="Please select one or more tasks" />
            </div>
            )}

            <div className="dsib-taskSelection__actions">
              <Button type="button" variant="primary" isFullWidth onClick={this.handleSubmit}>
                Next
              </Button>
              <Button
                type="button"
                variant="secondary"
                isFullWidth
                onClick={() => {
                  const { history } = this.props
                  history.push('/supplier')
                }}
              >
                Back
              </Button>
            </div>
          </div>
        </Container>
      </div>
    )
  }
}
export default TaskSelection
